export enum MaxValues {
  DEFAULT = 5
}

export interface BecomeExpertInProps {
  refInternal: any
  maxValues: number
  becomeExpertInItems: { [key: string]: string }
  indexOfItemInEditMode: number
  disabled?: boolean
  onAddItem: () => void
  onRemove: (key: number) => void
  onEditItem: (key: number) => void
  onChange: (index: number, value: any) => any
  onSubmitBecomeExpertIn: () => Promise<void>
}
